/**
 * 網址路徑結尾如果為「/」的話，就導向沒有「/」的路徑
 */

const provideNonSlashPath = (path: string, fullPath: string): string => {
  if (path.slice(-1) === '/') {
    const newPath = path.slice(0, -1);
    return fullPath.replace(path, newPath);
  }
  return path;
};

export default defineNuxtRouteMiddleware((to) => {
  const { path, fullPath } = to;

  if (path.length > 1 && path.slice(-1) === '/') {
    const result = provideNonSlashPath(path, fullPath);
    return navigateTo(result, { redirectCode: 301 });
  }
});
